import { render, staticRenderFns } from "./BasicFormComponent.vue?vue&type=template&id=53b0f961&"
import script from "./BasicFormComponent.vue?vue&type=script&lang=js&"
export * from "./BasicFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports